@reference "@glow/tailwind-config/reference.css";

.li {
  @apply list-none;
  @apply whitespace-nowrap;
  @apply px-4;
  @apply py-2;
  @apply text-emphasis-medium;
  @apply text-xs;
}
